export const dangerArray = [
    "epa_aqi_ozone",
    "epa_aqi_nitrogen",
    "epa_aqi_carbon_monoxide",
    "epa_aqi_sulfur_dioxide",
    "osm_lines_geo",
    "osm_multilines_geo",
    "osm_points_geo",
    "osm_multipolygons_geo",
    "osm_other_geo",
    "wildfires"
]